/**
 * iter94 — Issue 14: Test/Demo lead detection helpers.
 *
 * `is_test=true` (manually marked) is the source of truth.
 * `isSuspectedTestLead` is a soft visual hint when the name contains common
 * QA/dev patterns like "test", "iter", "demo" — used only to render a subtle
 * indicator, NEVER to hide leads automatically.
 */

const SUSPECT_PATTERNS = [
  /\btest\b/i,
  /\biter\b/i,
  /\bdemo\b/i,
  /\bqa\b/i,
  /\bsample\b/i,
];

const buildLeadName = (lead) => {
  if (!lead) return "";
  if (lead.name) return String(lead.name);
  const first = lead.first_name ? String(lead.first_name) : "";
  const last = lead.last_name ? String(lead.last_name) : "";
  return `${first} ${last}`.trim();
};

export const isSuspectedTestLead = (lead) => {
  if (!lead) return false;
  if (lead.is_test) return false; // already manually flagged, no need for a "maybe"
  const name = buildLeadName(lead);
  if (!name) return false;
  return SUSPECT_PATTERNS.some((re) => re.test(name));
};

export const isTestLead = (lead) => Boolean(lead && lead.is_test);
